import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Table,
  Button,
  CardFooter,
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
  Badge,
  Alert
} from "reactstrap";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { api } from "../../../config";
import EtapasProcesso from "../../../Components/Common/EtapaReserva";
import CadastroExpositor from "../../Expositores/Cadastro/index"; // Importando o componente de cadastro
import EstandeDetail from "../../../Components/Common/Estandedetalhes";
import { fetchComAuth, fetchComAuthJson } from "../../../common/api";
import CadastroEspaco from "../../Espacos/Cadastro/index";

const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

const ReservaDetalhes = ({gerouVenda}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [reserva, setReserva] = useState(null);
  const [tags, setTags] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalReprovar, setModalReprovar] = useState(false);
  const [modalExpositor, setModalExpositor] = useState(false); 
  const [modalCadastroEspaco, setModalCadastroEspaco] = useState(false); 
  const [modalEstande, setModalEstande] = useState(false); 
  const [loadingAprovacao, setLoadingAprovacao] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [arquivoExcluir, setArquivoExcluir] = useState(null);
  const [comerciais, setComercialFeira] = useState([]);
  const [permissaoCadastro, setPermissaoCadastro] = useState(false);

  const authUser = JSON.parse(sessionStorage.getItem("authUser")) || {};
  const userData = authUser.user || authUser;
  const userType = userData.tipo || '';

  const confirmarExclusao = (id) => {
    setArquivoExcluir(id);
    setModalDelete(true);
  };

  const fetchReserva = async (controller) => {
    try {
      setLoading(true);
      setError(null);
  
      const response = await fetchComAuth(`${api.API_URL}/reserva/${id}`, {
        method: 'GET',
        signal: controller ? controller.signal : undefined
      });
  
      const data = await response.json();
      setReserva(data.data.dados);
    
      setTags(data.data.tags);
      setLoading(false);
    } catch (err) {
      if (err.name === 'AbortError') {
        setError('Requisição demorou muito - tempo limite excedido');
      } else {
        setError(err.message || 'Falha ao carregar reserva');
      }
    }
  };
  
  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
  
    fetchReserva();
  
    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, [id]);

  useEffect(() => {
    const carregarComerciaisSalvos = async () => {
      if (!reserva) return;
  
      try {
        const response = await fetchComAuth(`${api.API_URL}/feira/comerciais/${reserva.feira_id}`, {
          method: 'GET'
        });
  
        const data = await response.json();
        setComercialFeira(data.data);
        
      } catch (err) {
        console.error("Erro ao carregar comerciais da feira", err);
      }
    };
    carregarComerciaisSalvos();
  }, [reserva]);

  useEffect(() => {
    const fetchPermissao = async () => {
      // ADICIONE ESTA LINHA: Se reserva for null, interrompe a execução
      if (!reserva) return;

      if (['JOTAPIX', 'EVOMAP'].includes(userType)) {
        setPermissaoCadastro(true);
      } else {
        try {
          const response = await fetchComAuth(`${api.API_URL}/dashboard/${reserva.feira_id}`, {
            method: 'GET'
          });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            
            const data = await response.json();
            
            if (!data) throw new Error("Dados vazios recebidos da API");
            
            setPermissaoCadastro(data.data.dados || []);
            
            if (data.data.permissao && ['COMERCIAL', 'ORGANIZACAO'].includes(userType)) {
              const acessos = data.data.permissao.filter((f) => f.chave_perfil === userType);
              const permissao = acessos.filter(a => a.dashboard_permissao.chave.includes('CADASTRO_ESPAÇOS'));
              
              setPermissaoCadastro(permissao.length > 0);
            }
            
            setError(null);
          } catch (error) {
              console.error("Erro ao buscar dados da feira:", error);
              setError(`Erro ao carregar dados: ${error.message}`);
          } finally {
            
          }
        }
        
      };

    fetchPermissao();
  }, [reserva]);
  
  const handleUpdateReserva = async () => {
    await fetchReserva();
  };

  const handleValidDate = date => {
    return moment(new Date(date)).format("DD/MM/YYYY");
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = getHour >= 12 ? "PM" : "AM";
    return moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
  };

  const handleExpositorAprovar = async () => {
    try {
      setLoadingAprovacao(true);

      const response = await fetchComAuthJson(`${api.API_URL}/reserva/expositor`, {
        method: 'POST',
        body: JSON.stringify({
          aprovado: true,
          reserva_id: reserva.id,
          expositor_id: reserva.expositor_id
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success("Expositor aprovado com sucesso!");
        setReserva(prev => ({
          ...prev,
          expositor: {
            ...prev.expositor,
            aprovado: true,
            pendente: false
          }
        }));
      } else {
        toast.error("Falha ao aprovar expositor!");
      }
    } catch (err) {
      toast.error("Falha ao aprovar expositor!");
    } finally {
      setLoadingAprovacao(false);
    }
  };

  const handleExpositorReprovar = async () => {
    try {
      setLoadingAprovacao(true);
    
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/expositor`, {
        method: 'POST',
        body: JSON.stringify({
          aprovado: false,
          reserva_id: reserva.id,
          expositor_id: reserva.expositor_id
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success("Expositor reprovado com sucesso!");
        setReserva(prev => ({
          ...prev,
          cancelado: true,
          expositor: {
            ...prev.expositor,
            aprovado: false,
            pendente: false
          }
        }));
      } else {
        toast.error("Falha ao reprovar expositor!");
      }
    } catch (err) {
      toast.error("Falha ao reprovar expositor!");
    } finally {
      setLoadingAprovacao(false);
    }
  };
  
  const handleExcluirArquivo = async (arquivoId) => {
      try {
       
        const response = await fetchComAuth(`${api.API_URL}/reserva/excluirArquivo/${arquivoId}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          toast.success("Arquivo excluído com sucesso!");
          setModalDelete(false);
          await handleUpdateReserva();
        } else {
          throw new Error('Falha ao excluir arquivo');
        }
      } catch (err) {
        console.error('Erro ao excluir arquivo:', err);
        toast.error(err.message || "Erro ao excluir arquivo");
      }
  };

  const formatarEndereco = (reserva) => {
    const end = reserva.expositor;
    
    if (!end.endereco && !end.numero && !end.complemento && !end.bairro && 
        !end.cidade && !end.estado && !end.pais && !end.cep) {
        return <p className="fw-medium mb-1">Sem endereço</p>;
    }

    const linhaEndereco = [
        end.endereco || null,
        end.numero ? end.numero : 'Sem número',
        end.complemento || null,
        end.bairro || null
    ].filter(Boolean).join(', ');

    const linhaCidadeEstado = [
        end.cidade || null,
        end.estado || null,
        end.pais || null
    ].filter(Boolean).join(', ');


    return (
        <>
        <h6 className="mb-1">
          <span className="fw-semibold"> Endereço:</span> 
        </h6>
            {linhaEndereco && <p className="mb-1">{linhaEndereco}</p>}
            {linhaCidadeEstado && <p className="mb-1">{linhaCidadeEstado}</p>}
            {end.cep && <p className="mb-1">{end.cep}</p>}
        </>
    );
  };

  const handleEspacoSalvo = () => {
    toggleModalCadastroEspaco();
    fetchReserva(); // Recarrega os detalhes da reserva para refletir as mudanças no estande
  };

  const toggleModalExpositor = () => setModalExpositor(!modalExpositor);
  const toggleModalCadastroEspaco = () => setModalCadastroEspaco(!modalCadastroEspaco);
  const toggleModalEstande = () => setModalEstande(!modalEstande);
  const toggleModalReprovar = () => setModalReprovar(!modalReprovar);
  const toggleModalDelete = () => setModalDelete(!modalDelete);

  document.title = "Reserva | EVOMAP - Tecnologia que conecta negócios";

  if (loading) return <div className="page-content">Carregando...</div>;
  if (error) return <div className="page-content">Erro: {error}</div>;
  if (!reserva) return <div className="page-content">Nenhuma reserva encontrada</div>;
  if (!reserva.estande) return <div className="page-content">Nenhum dado de reserva encontrado</div>;

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      {reserva && (
        <Container fluid>        
          <BreadCrumb 
            title="Detalhes" 
            pageTitle={reserva.gerou_venda ? "Venda" : "Reserva"} 
          />
          
          <Row className="justify-content-center">
            <Col xxl={9}>
              <Card>
                {/* Cabeçalho */}
                <CardHeader className="border-bottom-dashed p-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <Button 
                      color="primary" 
                      onClick={() => navigate(reserva.gerou_venda ? "/vendas" : "/reservas")}
                    >
                      <i className="ri-arrow-left-line align-bottom me-1"></i> Voltar
                    </Button>
                    
                    <div>
                      <Badge color={reserva.gerou_venda ? "success" : "primary"} className="me-2">
                        {reserva.gerou_venda ? 'VENDA' : 'RESERVA'} #{reserva.id}
                      </Badge>
                      <Badge color={reserva.cancelado ? "danger" : "success"}>
                        {reserva.cancelado ? 'CANCELADA' : 'ATIVA'}
                      </Badge>
                    </div>
                  </div>
                </CardHeader>

                {/* Informações principais */}
                <CardBody>
                  <Row className="mb-3">
                    
                    <Col md={6}>
                      <h5 className="mb-3">
                        <i className="ri-user-line align-bottom me-2"></i> 
                        Informações do Expositor
                      </h5>
                      
                      <div className="d-flex align-items-start mb-3">
                        <div className="flex-grow-1">
                          <h6 className="mb-1">
                            <span className="fw-semibold">Nome:</span> {reserva.expositor.nome}
                          </h6>
                          <p className="mb-1">
                            <span className="fw-semibold">CNPJ/Código:</span> {reserva.expositor.cnpj_codigo_internacional || 'Não informado'}
                          </p>
                          <p className="mb-1">
                            <span className="fw-semibold">Contato:</span> {reserva.expositor.telefone || 'Não informado'}
                          </p>
                          <p className="mb-1">
                            <span className="fw-semibold">WhatsApp:</span> {reserva.expositor.whatsapp || 'Não informado'}
                          </p>
                          <p className="mb-1">
                            <span className="fw-semibold">E-mail:</span> {reserva.expositor.email || 'Não informado'}
                          </p>
                        </div>

                        <div>
                          <Button 
                            color="info" 
                            size="sm" 
                            outline
                            onClick={toggleModalExpositor}
                          >
                            <i className="ri-eye-line align-bottom me-1"></i> Ver Completo
                          </Button>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md={6}>
                      <h5 className="mb-3">
                        <i className="ri-calendar-line align-bottom me-2"></i> 
                        Datas
                      </h5>
                      
                      <p className="mb-1">
                        <span className="fw-semibold">Solicitado:</span> {handleValidDate(reserva.created_at)} às {handleValidTime(reserva.created_at)}
                      </p>
                      <p className="mb-1">
                        <span className="fw-semibold">Atualizado:</span> {handleValidDate(reserva.updated_at)} às {handleValidTime(reserva.updated_at)}
                      </p>
                      
                      {reserva.expositor.pendente ? (
                        <Alert color="warning" className="mt-3">
                          <i className="ri-alert-line align-bottom me-2"></i>
                          Expositor aguardando aprovação
                        </Alert>
                      ) : (
                        <div className="mt-3">
                          <span className="fw-semibold">Status Expositor:</span>{' '}
                          {reserva.expositor.aprovado ? (
                            <Badge color="success" className="ms-2">Aprovado</Badge>
                          ) : (
                            <Badge color="danger" className="ms-2">Reprovado</Badge>
                          )}
                        </div>
                      )}
                    </Col>

                    <Col xl={12}>
                      {formatarEndereco(reserva)}
                    </Col>
                  </Row>

                  {/* Aprovação do expositor */}
                  {reserva.expositor.pendente && (
                    <Row className="mb-3">
                      <Col>
                        <div className="d-flex justify-content-end gap-2">
                          <Button 
                            color="danger" 
                            onClick={toggleModalReprovar}
                            disabled={loadingAprovacao}
                          >
                            {loadingAprovacao ? "Processando..." : (
                              <>
                                <i className="mdi mdi-close-circle-outline align-middle me-1"></i>
                                Reprovar Expositor
                              </>
                            )}
                          </Button>
                        
                          <Button 
                            color="success" 
                            disabled={loadingAprovacao}
                            onClick={handleExpositorAprovar}
                          >
                            {loadingAprovacao ? "Processando..." : (
                              <>
                                <i className="mdi mdi-check-bold align-middle me-1"></i>
                                Aprovar Expositor
                              </>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* Itens da reserva */}
                  <Row>
                    <div className="d-flex justify-content-between align-items-center ">
                      <Col md={8}>
                        <h5 className="mb-3">
                          <i className="ri-shopping-basket-line align-bottom me-2"></i> 
                          Itens da {reserva.gerou_venda ? 'Venda' : 'Reserva'}
                        </h5>
                      </Col>
                      <div>
                        <Button 
                            color="info" 
                            size="sm" 
                            outline
                            onClick={toggleModalEstande}
                          >
                            <i className="ri-eye-line align-bottom me-1"></i> Ver Espaço
                        </Button>
                    
                        {' '}
                      {permissaoCadastro && (
                        <Button 
                            color="success" 
                            size="sm" 
                            outline
                            onClick={toggleModalCadastroEspaco}
                          >
                            <i className="ri-edit-line align-bottom me-1"></i> Editar Espaço
                        </Button>
                      )}
                      </div>
                    </div>
                    </Row>

                    <Row>
                      <div className="table-responsive">
                        <Table bordered className="mb-0">
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: "50px" }}>#</th>
                              <th>Item</th>
                              <th>Valor Unitário</th>
                              <th>Quantidade</th>
                              <th className="text-end">Valor Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">1</th>
                              <td>
                                <span className="fw-medium">
                                  {reserva?.estande?.nome || 'Espaço'} -  
                                  {reserva?.estande?.largura || '0'}m x {reserva?.estande?.comprimento || '0'}m
                                </span>
                                <p className="text-muted mb-0">Espaço solicitado {reserva?.estande?.pavilhao?.nome || ''} </p>
                                <p className="text-muted mb-0">{reserva?.estande?.metragem_bonificada > 0 ? `Metragem Bonificada: `+ reserva?.estande?.metragem_bonificada + 'm²' : ''}</p>
                              </td>
                              <td>R$ {(reserva?.estande?.valor || 0).toFixed(2)}</td>
                              <td>{(reserva?.estande?.area || 0)} m²</td>
                              <td className="text-end">R$ {(reserva?.estande?.valor_total || 0).toFixed(2)}</td>
                            </tr>
                            
                            {/* KVA - Verifica se existe KVA vinculado ou se há valor manual salvo */}
                            {(reserva?.estande?.kva != null || reserva?.estande?.kva_manual) && (
                              <tr style={{ borderBottom: "1px solid #ddd" }}>
                                <th scope="row">2</th>
                                <td>
                                  <span className="fw-medium">
                                    KVA {reserva.estande.kva_manual && <Badge color="info" className="ms-1">Manual</Badge>}
                                  </span>
                                  <p className="text-muted mb-0">Item adicional</p>
                                </td>
                                <td style={{ padding: "0.5rem" }}>
                                  {reserva.estande.kva_manual 
                                    ? formatCurrency(reserva.estande.kva_valor_salvo / (reserva.estande.kva_quantidade_salva || 1))
                                    : formatCurrency(reserva.estande.kva?.valor / (reserva.estande.kva?.quantidade || 1))}
                                </td>
                                <td style={{ padding: "0.5rem" }}>
                                  {reserva.estande.kva_manual 
                                    ? (reserva.estande.kva_quantidade_salva || 1)
                                    : (reserva.estande.kva?.cobra_por_metro ? reserva.estande.area : reserva.estande.kva?.quantidade)}
                                </td>
                                <td style={{ padding: "0.5rem", textAlign: "right" }}>
                                  {reserva.estande.kva_manual 
                                    ? formatCurrency(reserva.estande.kva_valor_salvo)
                                    : formatCurrency(reserva.estande.kva?.cobra_por_metro ? (reserva.estande.kva?.valor * reserva.estande.area) : reserva.estande.kva?.valor)}
                                </td>
                              </tr>
                            )}

                            {/* Estacionamento - Verifica se existe Estacionamento ou se há valor manual salvo */}
                            {(reserva?.estande?.estacionamento != null || reserva?.estande?.estacionamento_manual) && (
                              <tr style={{ borderBottom: "1px solid #ddd" }}>
                                <th scope="row">3</th>
                                <td>
                                  <span className="fw-medium">
                                    Estacionamento {reserva.estande.estacionamento_manual && <Badge color="info" className="ms-1">Manual</Badge>}
                                  </span>
                                  <p className="text-muted mb-0">Item adicional</p>
                                </td>
                                <td className="right" style={{ padding: "0.5rem" }}>
                                  {reserva.estande.estacionamento_manual 
                                    ? (reserva.estande.estacionamento_valor_salvo <= 0 ? 0 :
                                      formatCurrency(reserva.estande.estacionamento_valor_salvo / (reserva.estande.estacionamento?.quantidade || 1)))
                                    : formatCurrency(reserva.estande.estacionamento?.valor / reserva.estande.estacionamento?.quantidade)}
                                </td>
                                <td className="right" style={{ padding: "0.5rem" }}>
                                  {reserva.estande.estacionamento_manual 
                                    ? (reserva.estande.estacionamento_quantidade_salva || 1)
                                    : reserva.estande.estacionamento?.quantidade}
                                </td>
                                <td style={{ padding: "0.5rem", textAlign: "right" }}>
                                  {reserva.estande.estacionamento_manual 
                                    ? formatCurrency(reserva.estande.estacionamento_valor_salvo)
                                    : formatCurrency(reserva.estande.estacionamento?.valor)}
                                </td>
                              </tr>
                            )}

                            {/* Tags / Adicionais - Cruza a configuração da feira com os valores do pivô no estande */}
                            {reserva.estande.tags?.map((tagEstande, index) => {
                              const isManual = tagEstande.manual || tagEstande.manual;
                              const valorUnitario = isManual ? tagEstande.valor_salvo : (tags?.find(t => t.tag_id === tagEstande.id)?.valor || 0);
                              const quantidade = isManual && tagEstande.quantidade_salva > 0 ? tagEstande.quantidade_salva : (tagEstande.tag[0].cobra_por_metro ? reserva.estande.area : 1);
                              
                              const valorTotalTag = isManual ?
                                (tagEstande.quantidade_salva > 0 ? tagEstande.valor_salvo * tagEstande.quantidade_salva : 
                                (tagEstande.valor_salvo * (tagEstande.tag[0].cobra_por_metro ? reserva.estande.area : 1))) : 
                                (valorUnitario * (tagEstande.tag[0].cobra_por_metro ? reserva.estande.area : 1));

                              return (
                                <tr key={`tag-${tagEstande.id}`}>
                                  <th scope="row">{index + 4}</th>
                                  <td>
                                    <span className="fw-medium">
                                      {tagEstande.nome} {isManual && <Badge color="info" className="ms-1">Manual</Badge>}
                                    </span>
                                    <p className="text-muted mb-0">Item adicional</p>
                                  </td>
                                  <td>{formatCurrency(valorUnitario)}</td>
                                  <td>{tagEstande.manual && tagEstande.quantidade_salva > 0 ? quantidade :
                                    tagEstande.tag[0].cobra_por_metro ? `${reserva.estande.area} m²` : quantidade}</td>
                                  <td className="text-end">{formatCurrency(valorTotalTag)}</td>
                                </tr>
                              );
                            })}

                          </tbody>
                         
                          <tfoot className="table-light">
                            {(() => {
                              const subtotalEstande = reserva?.estande?.valor_total || 0;

                              const totalKva = reserva.estande.kva_manual 
                                ? (reserva.estande.kva_valor_salvo || 0) 
                                : (reserva.estande.kva ? (reserva.estande.kva.cobra_por_metro ? reserva.estande.kva.valor * reserva.estande.area : reserva.estande.kva.valor) : 0);

                              const totalEstacionamento = reserva.estande.estacionamento_manual
                                ? (reserva.estande.estacionamento_valor_salvo || 0)
                                : (reserva.estande.estacionamento ? (reserva.estande.estacionamento.valor) : 0);

                              const totalTags = reserva.estande.tags?.reduce((sum, tag) => {
                                
                                const valorUnitario = tag.manual
                                  ? (tag.valor_salvo || tag.valor_salvo)
                                  : (tags?.find(t => t.tag_id === tag.id)?.valor || 0);

                                const qtd = tag.manual && tag.quantidade_salva > 0 ? tag.quantidade_salva :
                                (tag.tag[0].cobra_por_metro ? reserva.estande.area : 1);
                                
                                return sum + (valorUnitario * qtd);
                              }, 0) || 0;


                              const valorTotal = subtotalEstande + totalKva + totalEstacionamento + totalTags;

                              return (
                                <>
                                  <tr>
                                    <td colSpan="3" className="border-0"></td>
                                    <td className="border-0 fw-semibold">Subtotal (Itens)</td>
                                    <td className="border-0 text-end fw-semibold">
                                      {formatCurrency(subtotalEstande)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan="3" className="border-0"></td>
                                    <td className="border-0 fw-bold">Total</td>
                                    <td className="border-0 text-end fw-bold">
                                      {formatCurrency(valorTotal)}
                                    </td>
                                  </tr>
                                </>
                              );
                            })()}
                          </tfoot>
                        </Table>
                      </div>
                   
                  </Row>

                  {/* Observações */}
                  {reserva.observacao && (
                    <Row className="mt-1">
                        <Col md={12} className="mb-1">
                          <Card className="border border-2 border-warning shadow-sm">
                            <CardHeader className="bg-warning bg-opacity-10">
                              <h5 className="mb-0 text-warning">
                                Observação
                              </h5>
                            </CardHeader>
                            <CardBody>
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1 ms-3">
                                  <h6 className="mb-1">{reserva.observacao}</h6>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                    </Row>
                  )}

                {/* Informações de pagamento e comercial */}
                <Row className="mt-1">
                  {/* Seção de Pagamento Original */}
                  <Col md={4} className="mb-1">
                    <Card className="h-100 border border-2 border-light shadow-sm">
                      <CardHeader className="bg-light">
                        <h5 className="mb-0">
                          <i className="ri-bank-card-line align-bottom me-2 text-primary"></i>
                          Pagamento Original
                         
                        </h5>
                         <span className="ms-2">{formatCurrency(reserva.estande.valor_total_geral)}</span>
                      </CardHeader>
                      <CardBody>
                        
                        <div className="d-flex align-items-center mb-2">
                          <div className="flex-shrink-0">
                            <i className="ri-wallet-3-line fs-4 text-muted"></i>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="mb-0">Forma de Pagamento</h6>
                            <p className="text-muted mb-0">
                              {reserva.forma_pagamento.nome || 'Não informado'}
                            </p>
                          </div>
                        </div>
                        
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <i className="ri-calendar-todo-line fs-4 text-muted"></i>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="mb-0">Condição de Pagamento</h6>
                            <p className="text-muted mb-0">
                              {reserva.condicao_pagamento.nome || 'Não informado'}
                            </p>
                          </div>
                        </div>

                      </CardBody>
                    </Card>
                  </Col>

                  {/* Seção de Pagamento Negociado (condicional) */}
                  {reserva.alterado_financeiro && (
                    <Col md={4} className="mb-1">
                      <Card className="h-100 border border-2 border-success shadow-sm">
                        <CardHeader className="bg-success bg-opacity-10">
                          <h5 className="mb-0 text-success">
                            <i className="ri-exchange-dollar-line align-bottom me-2"></i>
                            Pagamento Negociado
                            <span className="badge bg-success ms-2">Atualizado -  {formatCurrency(reserva.valor_total_financeiro)}</span>
                          </h5>
                        </CardHeader>
                        <CardBody>
                          <div className="d-flex align-items-center mb-2">
                            <div className="flex-shrink-0">
                              <i className="ri-wallet-3-line fs-4 text-success"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="mb-0">Forma de Pagamento</h6>
                              <p className="text-success mb-0">
                                {reserva.forma_pagamento_financeiro != null ? reserva.forma_pagamento_financeiro.nome : 'Não informado'}
                              </p>
                            </div>
                          </div>
                          
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-calendar-todo-line fs-4 text-success"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="mb-0">Condição de Pagamento</h6>
                              <p className="text-success mb-0">
                                {reserva.condicao_pagamento_financeiro  != null ? reserva.condicao_pagamento_financeiro.nome : 'Não informado'}
                              </p>
                            </div>
                          </div>

                        </CardBody>
                      </Card>
                    </Col>
                  )}

                  {/* Seção Comercial */}
                  <Col md={4}>
                      <Card className="h-100 border border-2 border-light shadow-sm">
                      <CardHeader className="bg-light">
                        <h5 className="mb-0">
                          <i className="ri-bank-card-line align-bottom me-2 text-primary"></i>
                          Responsável Comercial
                        </h5>
                      </CardHeader>
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <i className="ri-account-circle-line fs-2 text-info"></i>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="mb-1">Vendedor</h6>
                            <p className="text-info mb-0 fw-semibold">
                              {reserva.comercial?.nome || 'Não informado'}
                            </p>
                            {reserva.comercial?.email && (
                              <a 
                                href={`mailto:${reserva.comercial.email}`}
                                className="text-muted small d-block"
                              >
                                <i className="ri-mail-line align-middle me-1"></i>
                                {reserva.comercial.email}
                              </a>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                {reserva.arquivos?.length > 0 && (
                  <Row className="mt-3">
                    <Col>
                      <h5 className="mb-3">
                        <i className="ri-attachment-line align-bottom me-2"></i>
                        Arquivos Anexados
                      </h5>
                      <div className="table-responsive">
                        <Table bordered>
                          <thead className="table-light">
                            <tr>
                              <th>Arquivo</th>
                              <th>Data de Envio</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reserva.arquivos.map((arquivo) => (
                              <tr key={arquivo.id}>
                                <td>
                                  <span className="fw-medium">
                                    {arquivo.nome_original || 'Arquivo'}
                                  </span>
                                  <p className="text-muted mb-0">{arquivo.observacao}</p>
                                </td>
                                <td>{handleValidDate(arquivo.created_at)}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <Button 
                                        color="primary" 
                                        size="sm" 
                                        onClick={() => window.open(`${arquivo.url}`, '_blank')}>
                                        <i className="ri-download-line align-bottom me-1"></i> Baixar
                                    </Button>
                                    
                                    <Button 
                                        color="danger" 
                                        size="sm" 
                                        onClick={() => confirmarExclusao(arquivo.id)}>
                                        <i className="ri-delete-bin-fill align-bottom me-1"></i> Excluir
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>)}
                  {/* Etapas do processo */}
                  <Row className="mt-3">
                    <Col>
                      <EtapasProcesso 
                        etapas={reserva.etapas} 
                        reservaId={reserva.id} 
                        feiraId={reserva.feira_id}
                        cancelada={reserva.cancelado}
                        venda={reserva.gerou_venda}
                        formaPagamentoId={reserva.forma_pagamento_id}
                        condicaoPagamentoId={reserva.condicao_pagamento_id}
                        valor={reserva.valor_total}
                        onUpdate={handleUpdateReserva}
                        comerciais={comerciais}
                        comercialId={reserva.comercial_id}
                      />
                    </Col>
                  </Row>
                </CardBody>

                <CardFooter>
                  <Button 
                    color="primary" 
                    onClick={() => navigate(reserva.gerou_venda ? "/vendas" : "/reservas")}
                  >
                    <i className="ri-arrow-left-line align-bottom me-1"></i> Voltar
                  </Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>

          {/* Modal para reprovar expositor */}
          <Modal isOpen={modalReprovar} toggle={toggleModalReprovar} centered>
            <ModalHeader toggle={toggleModalReprovar}>
              Confirmar Reprovação
            </ModalHeader>
            <ModalBody>
              <p>
                Ao reprovar o expositor, a reserva vinculada será <strong>automaticamente cancelada</strong> e não poderá ser recuperada.
              </p>
              <p>Tem certeza que deseja confirmar a reprovação?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalReprovar}>
                Voltar
              </Button>
              <Button color="danger" onClick={async () => {
                await handleExpositorReprovar();
                toggleModalReprovar();
              }}>
                Confirmar Reprovação
              </Button>
            </ModalFooter>
          </Modal>

          {/* Modal para visualizar dados completos do expositor */}
          <Modal 
            isOpen={modalExpositor} 
            toggle={toggleModalExpositor} 
            size="xl"
            scrollable
          >
            <ModalHeader toggle={toggleModalExpositor}>
              Dados Completos do Expositor
            </ModalHeader>
            <ModalBody>
              <CadastroExpositor 
                id={reserva.expositor_id} 
                feiraId={reserva.feira_id}
                onClose={() => setModalExpositor(false)}
                readOnly // Adicione esta prop se quiser que o modal seja apenas para visualização
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalExpositor}>
                Fechar
              </Button>
            </ModalFooter>
          </Modal>

           {/* Modal para visualizar dados completos do estande */}
          <Modal 
            isOpen={modalEstande} 
            toggle={toggleModalEstande} 
            size="xl"
            scrollable
          >
            <ModalHeader toggle={toggleModalEstande}>
              Dados Completos do Espaço
            </ModalHeader>
            <ModalBody>
              <EstandeDetail estande={reserva.estande} tags={tags}></EstandeDetail>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalEstande}>
                Fechar
            </Button>
          </ModalFooter>
          </Modal>

          <Modal isOpen={modalDelete} toggle={toggleModalDelete} centered>
              <div className="modal-header">
                <h5 className="modal-title">Confirmar exclusão</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalDelete(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <p className="fs-15">
                  Tem certeza que deseja excluir?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleModalDelete}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => { handleExcluirArquivo(arquivoExcluir)} }>
                  Confirmar
                </button>
              </div>
          </Modal>

          {/* Modal para visualizar dados completos do espaco */}
          <Modal 
            isOpen={modalCadastroEspaco} 
            toggle={toggleModalCadastroEspaco} 
            size="xl"
            scrollable
          >
            <ModalHeader toggle={toggleModalCadastroEspaco}>
              Editar Dados do Espaço (Estande)
            </ModalHeader>
            <ModalBody>
              <CadastroEspaco 
                feiraId={reserva.feira_id} 
                espacoId={reserva.estande_id || reserva.estande?.id} 
                isModal={true}
                onSaveSuccess={handleEspacoSalvo}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalCadastroEspaco}>
                Fechar
              </Button>
            </ModalFooter>
          </Modal>

      </Container>

          
    )}
  </div>
  );
};

export default ReservaDetalhes;